import { Config } from 'config/envConfig';
import React, { useEffect, useState } from 'react';
import {
    getFileFormat,
    isImageFile,
    isMarkdownFile,
    isTxtFile,
} from '@quyva/common';
import { PdfDebugContainer } from './pdfDisplay/debug/pdfDebugContainer';
import { SingleImageContainer } from './imageViewer/singleImageContainer';
import { SingleMarkdownContainer, SingleTxtContainer } from '@quyva/shared-ui';
import { getUrl } from './pdfDisplay/utils';

export const DebugViewerContainer = ({
    repoId,
    email,
    folderName,
    fileName,
    websiteUrl,
    mode,
    isAdmin,
}) => {
    const extension = getFileFormat(fileName);
    const [fileUrl, setFileUrl] = useState('');

    useEffect(() => {
        let endpoint = '';
        if (isMarkdownFile(extension)) {
            endpoint = 'get_markdown';
        } else if (isTxtFile(extension)) {
            endpoint = 'get_txt_file';
        }

        if (endpoint) {
            const url = `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/${endpoint}/?file_name=${fileName}&email=${email}&folder_name=${folderName}`;
            setFileUrl(getUrl(url));
        }
    }, [repoId, email, folderName, fileName, extension]);

    if (isImageFile(extension)) {
        return (
            <SingleImageContainer
                repoId={repoId}
                email={email}
                folderName={folderName}
                fileName={fileName}
            />
        );
    } else if (isMarkdownFile(extension)) {
        return (
            <SingleMarkdownContainer
                fileName={fileName}
                websiteUrl={websiteUrl}
                fileUrl={fileUrl}
            />
        );
    } else if (isTxtFile(extension)) {
        return <SingleTxtContainer fileName={fileName} fileUrl={fileUrl} />;
    }

    return (
        <PdfDebugContainer
            repoId={repoId}
            email={email}
            folderName={folderName}
            fileName={fileName}
            mode={mode}
            isAdmin={isAdmin}
        />
    );
};
